import React, { Component } from "react";
import { FaTasks, FaChartLine, FaUsers, FaMagic, FaCalendarAlt, FaClock, FaLightbulb, FaRobot } from "react-icons/fa";
import { AiOutlinePicture, AiOutlineAudio } from "react-icons/ai";
import Aos from "aos";
import "aos/dist/aos.css";
import "../../styles/BenefitsSection.css";

class BenefitsSection extends Component {
    componentDidMount() {
        Aos.init({ duration: 600, once: false });
    }

    render() {
        const benefitsData = [
            {
                icon: FaMagic,
                userBenefit: "Social Media Posting",
                description: "Automatically publish content to Instagram, LinkedIn, Facebook, and X — consistently and on schedule.",
            },
            {
                icon: FaUsers,
                userBenefit: "Lead Engagement",
                description: "Engage leads automatically with follow-ups, qualification messages, and booking flows.",
            },
            {
                icon: FaCalendarAlt,
                userBenefit: "Client Onboarding",
                description: "Send welcome emails, forms, Notion docs, and automate tasks the moment a client signs.",
            },
            {
                icon: FaChartLine,
                userBenefit: "Automated Email Campaigns",
                description: "Trigger personalized email sequences based on user behavior, stage, or segment.",
            },
            {
                icon: FaTasks,
                userBenefit: "Proposal Generation",
                description: "Turn intake info into clean, branded proposals in seconds — ready to send or sign.",
            },
            {
                icon: FaRobot,
                userBenefit: "AI Chatbot for Inquiries",
                description: "Answer client questions, qualify leads, and book calls with a custom-trained AI bot.",
            },
            {
                icon: FaLightbulb,
                userBenefit: "Client Reports in Notion",
                description: "Send automated, up-to-date client reports inside shared Notion workspaces — no manual updates.",
            },
            {
                icon: FaClock,
                userBenefit: "Pre-Call Preparation",
                description: "Auto-generate a call brief with key client info, project status, and context before every meeting.",
            },
            {
                icon: FaLightbulb,
                userBenefit: "Content Idea Generation",
                description: "We use AI to generate content ideas tailored to your brand, audience, and goals — so you never run out of fresh topics.",
            },
            {
                icon: FaMagic,
                userBenefit: "Custom Automations",
                description: "Have a unique workflow? We'll design and build a system around it — fully tailored to your business.",
            },
        ];



        return (
            <div className="benefits-grid-section" id="what-we-automate">
                <h2 className="benefits-title">What We Automate for You</h2>
                <p className="benefits-description">
                    We don’t just optimize — we build full automation systems that handle marketing, operations, and client engagement for you.
                </p>
                <div className="benefits-grid">
                    {benefitsData.map((benefit, index) => (
                        <div className="benefit-grid-item" key={index} data-aos="fade-up" data-aos-delay={`${index * 100}`}>
                            <div className="benefit-icon-wrapper">
                                <benefit.icon className="benefit-icon" />
                                <div className="background-accent"></div>
                            </div>
                            <h3 className="benefit-title">{benefit.userBenefit}</h3>
                            <p className="benefit-description">{benefit.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default BenefitsSection;